{
  "common": {
    "loading": "Cargando...",
    "cancel": "Cancelar",
    "save": "Guardar",
    "save_changes": "Guardar cambios",
    "delete": "Eliminar",
    "edit": "Editar",
    "close": "Cerrar",
    "submit": "Enviar",
    "saving": "Guardando...",
    "sending": "Enviando...",
    "error": "Error",
    "success": "Éxito",
    "warning": "Advertencia",
    "note": "Nota",
    "no_data": "Sin datos",
    "yes": "Sí",
    "no": "No",
    "back": "Atrás",
    "next": "Siguiente",
    "previous": "Anterior",
    "search": "Buscar",
    "filter": "Filtrar",
    "all": "Todo",
    "none": "Ninguno",
    "select": "Seleccionar",
    "required": "Requerido",
    "optional": "Opcional",
    "actions": "Acciones",
    "status": "Estado",
    "date": "Fecha",
    "time": "Hora",
    "name": "Nombre",
    "email": "Correo electrónico",
    "confirm": "Confirmar",
    "add": "Añadir",
    "done": "Hecho",
    "unknown": "Desconocido",
    "days": "días",
    "to": "a"
  },
  "time": {
    "day": "día",
    "days": "días",
    "hour": "hora",
    "hours": "horas",
    "week": "semana",
    "weeks": "semanas",
    "month": "mes",
    "months": "meses",
    "year": "año",
    "years": "años",
    "today": "Hoy",
    "tomorrow": "Mañana",
    "yesterday": "Ayer"
  },
  "status": {
    "pending": "Pendiente",
    "approved": "Aprobado",
    "rejected": "Rechazado",
    "cancelled": "Cancelado",
    "active": "Activo",
    "inactive": "Inactivo",
    "deleted": "Eliminado",
    "connected": "Conectado",
    "disconnected": "Desconectado",
    "available": "Disponible",
    "coming_soon": "Muy pronto"
  },
  "nav": {
    "dashboard": "Panel",
    "planner": "Planificador",
    "team": "Equipo",
    "requests": "Solicitudes",
    "calendar": "Calendario",
    "settings": "Ajustes",
    "audit_trail": "Pista de auditoría",
    "billing": "Facturación",
    "help": "Ayuda",
    "help_center": "Centro de ayuda",
    "profile": "Perfil",
    "my_balances": "Mis saldos",
    "leave_history": "Historial de permisos",
    "restart_tour": "Reiniciar tour",
    "logout": "Desconectar",
    "upgrade": "Actualizar a Pro",
    "upgrade_subtitle": "Desbloquea todas las funciones",
    "view_plans": "Ver planes"
  },
  "header": {
    "profile_settings": "Configuración del perfil",
    "my_profile": "Mi perfil",
    "workspace": "Espacio de trabajo",
    "leave_balances": "Saldos de licencia",
    "no_balances": "No se encontraron saldos de licencia."
  },
  "balance": {
    "unlimited": "Ilimitado",
    "days_left": "días restantes",
    "used": "usado",
    "remaining": "restante",
    "of": "de"
  },
  "trial": {
    "ends_today": "¡Tu prueba termina hoy!",
    "ends_tomorrow": "¡Tu prueba termina mañana!",
    "ends_in_days": "El juicio finaliza en {días} días.",
    "upgrade_now": "Actualizar ahora"
  },
  "feature_locked": {
    "title": "{feature} no está disponible en tu plan",
    "description": "Actualice su plan para desbloquear esta función y más.",
    "button": "Ver planes"
  },
  "dashboard": {
    "title": "Panel",
    "out_today": "Disponible hoy",
    "out_on_date": "Salió el {fecha}",
    "no_absences": "Sin ausencias",
    "upcoming": "Próximas ausencias",
    "upcoming_empty": "No hay ausencias próximas esta semana",
    "my_balance": "Mi saldo de vacaciones",
    "my_balances": "Mis saldos",
    "no_balance_data": "No hay datos de saldo",
    "next_holiday": "Próximo día festivo",
    "no_holidays": "No hay vacaciones próximas",
    "next_vacation": "Mis próximas vacaciones",
    "nothing_booked": "¡Nada reservado!",
    "upcoming_birthdays": "Próximos cumpleaños",
    "no_birthdays": "No hay cumpleaños próximos",
    "birthday_today": "¡Hoy!",
    "birthday_in_days": "en {days} {unit}",
    "everyone_in_office": "Todos están en la oficina en este día.",
    "request_leave": "Solicitar permiso",
    "view_calendar": "Ver calendario",
    "view_planner": "Ver Planificador",
    "contact_support": "Contactar con soporte técnico"
  },
  "support": {
    "title": "Contactar con soporte técnico",
    "success_title": "¡Mensaje enviado!",
    "success_message": "Nos pondremos en contacto con usted lo antes posible.",
    "intro": "¿Necesitas ayuda? Envíanos un mensaje y te responderemos en breve.",
    "subject_label": "Sujeto",
    "subject_placeholder": "Breve descripción de su problema",
    "message_label": "Mensaje",
    "message_placeholder": "Por favor describa su problema o pregunta en detalle...",
    "send_button": "Enviar mensaje"
  },
  "requests": {
    "page_title": "Solicitudes de licencia",
    "page_subtitle": "Revisar y gestionar solicitudes de licencia",
    "new_request": "Solicitar permiso",
    "unpaid_confirm": "Solo {paid} {unit} de esta solicitud están cubiertas por tu saldo pagado. Las {unpaid} {unit} restantes se tomarán como vacaciones no remuneradas. ¿Enviar de todos modos?",
    "filter": {
      "pending": "Pendiente",
      "approved": "Aprobado",
      "rejected": "Rechazado",
      "all": "Todo",
      "all_employees": "Todos los empleados"
    },
    "table": {
      "employee": "Empleado",
      "type": "Tipo",
      "dates": "Fechas",
      "duration": "Duración",
      "status": "Estado",
      "reason": "Razón",
      "actions": "Comportamiento"
    },
    "action": {
      "approve": "Aprobar",
      "reject": "Rechazar",
      "cancel": "Cancelar"
    },
    "empty": {
      "title": "No se encontraron solicitudes",
      "pending": "No hay solicitudes pendientes de revisión.",
      "filtered": "No hay solicitudes de licencia que coincidan con tu filtro."
    },
    "modal": {
      "reject_title": "Rechazar solicitud",
      "reason_label": "Motivo del rechazo",
      "reason_placeholder": "Motivo de la solicitud de licencia...",
      "reject_button": "Rechazar",
      "request_title": "Solicitar permiso",
      "employee_label": "Empleado",
      "leave_type_label": "Tipo de licencia",
      "start_date_label": "Fecha de inicio",
      "end_date_label": "Fecha de finalización",
      "start_time_label": "Hora de inicio",
      "end_time_label": "Fin de los tiempos",
      "reason_optional": "Razón (opcional)",
      "submit_button": "Enviar solicitud",
      "submitting": "Sumisión...",
      "minimum_duration": "Mínimo: {duration} {unit}"
    }
  },
  "calendar": {
    "page_title": "Calendario del equipo",
    "page_subtitle": "Ver las ausencias del equipo y las licencias programadas",
    "filters": {
      "button": "Filtros"
    },
    "sync": {
      "title": "Sincroniza tu calendario",
      "description": "Conecte su calendario personal para sincronizar automáticamente las licencias aprobadas"
    },
    "connect": {
      "google": "Calendario de Google",
      "microsoft": "Calendario de Microsoft"
    },
    "action": {
      "disconnect": "Desconectar",
      "sync_my_leave": "Sincronizar mis vacaciones",
      "sync_team_leave": "Sincronizar equipo salir"
    },
    "connecting": "Conectando...",
    "syncing": "Sincronizando...",
    "autosync": {
      "title": "Sincronización automática de salida del equipo",
      "description": "Agregue automáticamente las licencias aprobadas de los miembros del equipo a su calendario"
    },
    "filter": {
      "department_label": "Departamento",
      "all_departments": "Todos los departamentos",
      "location_label": "Ubicación",
      "all_locations": "Todas las ubicaciones",
      "leave_type_label": "Tipo de licencia",
      "all_types": "Todos los tipos",
      "status_label": "Estado",
      "all_status": "Todos los estados"
    },
    "nav": {
      "today": "Hoy"
    },
    "view": {
      "day": "Día",
      "week": "Semana",
      "month": "Mes"
    },
    "legend": {
      "pending": "Pendiente",
      "holiday": "Día festivo"
    },
    "day_view": {
      "empty": "No hay hojas en este día"
    },
    "more": "+{count} más"
  },
  "team": {
    "page_title": "Equipo",
    "page_subtitle": "Gestiona a los miembros de tu equipo",
    "tab": {
      "active": "Activos",
      "inactive": "Inactivos",
      "deleted": "Eliminados"
    },
    "add_user": "Agregar usuario",
    "import_from_slack": "Importar desde Slack",
    "search_placeholder": "Buscar miembros del equipo...",
    "showing_results": "Mostrando {showing} de {total} miembros {status}",
    "table": {
      "name": "Nombre",
      "email": "Correo electrónico",
      "department": "Departamento",
      "role": "Rol",
      "status": "Estado",
      "actions": "Acciones"
    },
    "filter": {
      "search_placeholder": "Buscar miembros del equipo...",
      "all_departments": "Todos los departamentos",
      "all_locations": "Todas las ubicaciones",
      "all_roles": "Todos los roles"
    },
    "role": {
      "owner": "Propietario",
      "admin": "Administrador",
      "approver": "Aprobador",
      "employee": "Empleado",
      "user": "Usuario"
    },
    "card": {
      "no_email": "Sin correo",
      "no_department": "Sin departamento",
      "no_location": "Sin ubicación",
      "reports_to": "Reporta a",
      "leave_balances": "Saldos de ausencias"
    },
    "action": {
      "bulk_import": "Importación masiva",
      "invite_member": "Invitar miembro",
      "edit": "Editar",
      "toil": "TOIL",
      "instances": "Instancias",
      "deactivate": "Desactivar",
      "remove": "Eliminar",
      "activate": "Activar",
      "delete": "Eliminar",
      "restore": "Restaurar",
      "permanent_delete": "Eliminar permanentemente"
    },
    "empty": {
      "active_title": "No se encontraron miembros activos",
      "active_description": "Invita miembros del equipo para comenzar",
      "inactive_title": "No se encontraron miembros inactivos",
      "inactive_description": "No hay usuarios desactivados",
      "deleted_title": "No se encontraron miembros eliminados",
      "deleted_description": "No hay usuarios eliminados",
      "adjust_filters": "Intenta ajustar los filtros"
    },
    "modal": {
      "edit_title": "Editar miembro del equipo",
      "role": "Rol",
      "owner_role_locked": "El rol del propietario del espacio de trabajo no se puede cambiar",
      "department": "Departamento",
      "no_department": "Sin departamento",
      "location": "Ubicación",
      "no_location": "Sin ubicación",
      "holiday_location": "Ubicación de festivos",
      "use_assigned_location": "Usar ubicación asignada",
      "holiday_location_help": "Anular qué festivos del país aplican a este usuario",
      "manager": "Gerente",
      "no_manager": "Sin gerente",
      "start_date": "Fecha de inicio",
      "birthday": "Cumpleaños",
      "birthday_help": "Se usa para notificaciones de cumpleaños",
      "city": "Ciudad (para el clima)",
      "city_placeholder": "ej., Madrid, Barcelona, Valencia",
      "city_help": "Anular la ciudad de la ubicación para clima personalizado. Dejar en blanco para usar el predeterminado.",
      "custom_working_days": "Días laborales personalizados",
      "custom_working_days_help": "Anular los días laborales predeterminados del departamento para este usuario (ej., horario a tiempo parcial)",
      "working_days": "Días laborales",
      "working_days_help": "Selecciona los días que trabaja este empleado (las solicitudes de ausencia solo contarán estos días)"
    },
    "toil": {
      "title": "Gestionar TOIL",
      "subtitle": "Tiempo libre compensatorio (TOIL)",
      "current_balance": "Saldo TOIL actual",
      "available": "disponible",
      "granted": "otorgado",
      "used": "usado",
      "hours_to_add": "Horas a agregar",
      "hours_placeholder": "ej., 4 u 8",
      "hours_help": "8 horas = 1 día de TOIL",
      "reason": "Razón",
      "reason_placeholder": "ej., Trabajé el sábado para el lanzamiento del sitio web",
      "note": "Las horas TOIL se agregan al saldo de vacaciones del usuario pero se rastrean por separado. El TOIL NO se transfiere al año siguiente.",
      "adding": "Agregando...",
      "add_hours": "Agregar horas TOIL"
    },
    "invite": {
      "title": "Agregar miembro del equipo",
      "description": "Busca miembros de Slack que aún no se han agregado al rastreador de vacaciones. Esto incluye miembros invitados (invitados de un solo canal y multicanal).",
      "search_placeholder": "Buscar por nombre o correo...",
      "searching": "Buscando usuarios de Slack...",
      "no_results": "No se encontraron usuarios de Slack coincidentes",
      "all_added": "Todos los usuarios de Slack ya han sido agregados",
      "single_channel_guest": "Invitado de un solo canal",
      "multi_channel_guest": "Invitado multicanal",
      "adding": "Agregando..."
    },
    "bulk": {
      "title": "Importación masiva desde Slack",
      "description": "Importa miembros del equipo desde tu espacio de trabajo de Slack. Elige qué tipos de miembros incluir.",
      "loading": "Cargando espacio de trabajo de Slack...",
      "workspace_members": "Miembros del espacio de trabajo de Slack",
      "full_members": "Miembros completos",
      "multi_channel_guests": "Invitados multicanal",
      "single_channel_guests": "Invitados de un solo canal",
      "already_imported": "Ya importados: {count} usuarios",
      "who_to_import": "¿A quién deseas importar?",
      "all_members": "Todos los miembros ({count})",
      "all_members_desc": "Miembros completos + todos los tipos de invitados",
      "full_and_multi": "Miembros completos + invitados multicanal ({count})",
      "full_and_multi_desc": "Excluye invitados de un solo canal",
      "full_only": "Solo miembros completos ({count})",
      "full_only_desc": "Excluye todos los tipos de invitados",
      "import_complete": "¡Importación completa!",
      "import_result": "{created} nuevos usuarios importados, {updated} usuarios existentes actualizados",
      "load_failed": "Error al cargar los datos del espacio de trabajo de Slack",
      "importing": "Importando...",
      "import_users": "Importar {count} usuarios"
    },
    "instances": {
      "title": "Instancias de ausencias",
      "subtitle": "Instancias de ausencias por evento (maternidad, paternidad, etc.)",
      "loading": "Cargando instancias...",
      "active": "Instancias activas",
      "new_instance": "+ Nueva instancia",
      "leave_type": "Tipo de ausencia",
      "select_leave_type": "Seleccionar tipo de ausencia...",
      "name": "Nombre (opcional)",
      "name_placeholder": "ej., Bebé #1, Sabático 2025",
      "start_date": "Fecha de inicio",
      "entitlement": "Derecho",
      "entitlement_placeholder": "ej., 18",
      "creating": "Creando...",
      "create": "Crear instancia",
      "no_active": "Sin instancias activas",
      "remaining": "{remaining} de {total} {unit} restantes",
      "started": "Iniciado {date}",
      "mark_complete": "Marcar como completado",
      "complete": "Completar",
      "past": "Instancias pasadas",
      "used": "Usado {used} de {total} {unit}",
      "closed": "Cerrado {date}",
      "status_completed": "completado",
      "status_cancelled": "cancelado"
    },
    "confirm": {
      "deactivate": "¿Estás seguro que deseas desactivar este usuario?",
      "delete": "¿Seguro que desea eliminar a este usuario? Se moverá a la pestaña Eliminados.",
      "permanent_delete": "¿Estás seguro que deseas ELIMINAR PERMANENTEMENTE {name}?",
      "permanent_delete_warning": "Esta acción no se puede deshacer. Se eliminarán todos sus saldos e historial de ausencias.",
      "permanent_delete_final": "¡Esto es permanente! Haga clic en Aceptar para confirmar la eliminación definitiva."
    },
    "error": {
      "deactivate": "No se pudo desactivar el usuario",
      "activate": "No se pudo activar el usuario",
      "delete": "No se pudo eliminar el usuario",
      "restore": "No se pudo restaurar el usuario",
      "permanent_delete": "No se pudo eliminar el usuario de forma permanente"
    }
  },
  "settings": {
    "page_title": "Ajustes",
    "page_subtitle": "Configure los ajustes y políticas de su espacio de trabajo",
    "access_denied": {
      "title": "Se requiere acceso de administrador",
      "message": "Necesita permisos de administrador para acceder a la configuración."
    },
    "tab": {
      "workspace": "Espacio de trabajo",
      "departments": "Departamentos",
      "locations": "Ubicaciones",
      "holidays": "Vacaciones",
      "compliance": "Cumplimiento",
      "balances": "Saldos iniciales",
      "notifications": "Notificaciones",
      "integrations": "Integraciones",
      "import": "Importar",
      "data_management": "Gestión de datos",
      "locked_tooltip": "Actualice para desbloquear esta función"
    },
    "workspace": {
      "title": "Configuración del espacio de trabajo",
      "name_label": "Nombre del espacio de trabajo",
      "visibility_label": "Dejar visibilidad",
      "visibility": {
        "all": "Todos pueden ver que todo se va.",
        "department": "Ver solo el propio departamento",
        "approvers": "Sólo los aprobadores pueden ver todo"
      },
      "save_button": "Guardar cambios"
    },
    "departments": {
      "title": "Departamentos",
      "subtitle": "Organiza tu equipo en departamentos con políticas personalizadas",
      "add_button": "Agregar departamento",
      "name_label": "Nombre del departamento",
      "working_days_label": "Días laborables",
      "hours_per_day_label": "Horas por día",
      "approvers_label": "Aprobadores",
      "notification_channel_label": "Canal de notificación",
      "policies_button": "Administrar políticas",
      "edit_button": "Editar",
      "delete_button": "Borrar",
      "confirm_delete": "¿Está seguro de que desea eliminar este departamento?",
      "no_departments": "Aún no se han creado departamentos"
    },
    "locations": {
      "title": "Ubicaciones",
      "subtitle": "Administrar las ubicaciones de las oficinas y sus calendarios de vacaciones",
      "add_button": "Agregar ubicación",
      "name_label": "Nombre de la ubicación",
      "country_label": "País",
      "timezone_label": "Zona horaria",
      "edit_button": "Editar",
      "delete_button": "Borrar",
      "no_locations": "Aún no se han creado ubicaciones"
    },
    "holidays": {
      "title": "Días festivos",
      "subtitle": "Gestionar los días festivos de cada ubicación",
      "add_button": "Añadir vacaciones",
      "location_label": "Ubicación",
      "all_locations": "Todas las ubicaciones",
      "year_label": "Año",
      "name_label": "Nombre de la festividad",
      "date_label": "Fecha",
      "half_day_label": "Medio día",
      "edit_button": "Editar",
      "delete_button": "Borrar",
      "no_holidays": "No hay días festivos para esta ubicación y año.",
      "import_button": "Importar días festivos"
    },
    "leave_types": {
      "title": "Tipos de licencia",
      "subtitle": "Configurar tipos de licencia y derechos",
      "add_button": "Agregar tipo de licencia",
      "name_label": "Nombre",
      "color_label": "Color",
      "unit_label": "Unidad",
      "unit": {
        "days": "Días",
        "hours": "Horas"
      },
      "entitlement_label": "Derecho predeterminado",
      "unlimited": "Ilimitado",
      "requires_approval_label": "Requiere aprobación",
      "allow_half_day_label": "Permitir medio día",
      "is_paid_label": "Licencia remunerada",
      "carryover_label": "Máximo arrastre",
      "priority_label": "Prioridad",
      "edit_button": "Editar",
      "delete_button": "Borrar",
      "no_leave_types": "No hay tipos de licencia configurados"
    },
    "notifications": {
      "title": "Notificaciones",
      "subtitle": "Configurar cómo y cuándo se envían las notificaciones",
      "slack_channel_label": "Canal de Slack",
      "email_notifications_label": "Notificaciones por correo electrónico",
      "daily_digest_label": "Resumen diario",
      "weekly_summary_label": "Resumen semanal",
      "save_button": "Guardar configuración"
    },
    "integrations": {
      "title": "Integraciones",
      "subtitle": "Conecte sus herramientas y calendarios de RR.HH.",
      "connect_button": "Conectar",
      "disconnect_button": "Desconectar",
      "sync_button": "Sincronizar ahora",
      "view_logs_button": "Ver registros",
      "last_sync": "Última sincronización: {fecha}",
      "never_synced": "Nunca sincronizado",
      "status": {
        "connected": "Conectado",
        "disconnected": "No conectado",
        "error": "Error"
      }
    },
    "data": {
      "title": "Gestión de datos",
      "subtitle": "Realice una copia de seguridad de sus datos o borre la información del espacio de trabajo",
      "current_data": "Datos actuales",
      "total_users": "Total de usuarios",
      "admins": "Administradores",
      "regular_users": "Usuarios regulares",
      "leave_requests": "Solicitudes de licencia",
      "backup": {
        "title": "Descargar copia de seguridad",
        "description": "Descargue una copia de seguridad completa de los datos de su espacio de trabajo como un archivo JSON.",
        "button": "Descargar copia de seguridad"
      },
      "google_drive": {
        "title": "Copia de seguridad de Google Drive",
        "description": "Copias de seguridad diarias automáticas en Google Drive.",
        "connect_button": "Conectar Google Drive",
        "folder_label": "Carpeta de respaldo",
        "auto_backup_label": "Habilitar la copia de seguridad diaria automática",
        "backup_now_button": "Copia de seguridad ahora",
        "last_backup": "Última copia de seguridad: {fecha}",
        "upgrade_message": "Las copias de seguridad diarias automáticas en Google Drive están disponibles en el plan Business."
      },
      "clear_users": {
        "title": "Borrar usuarios no administradores",
        "description": "Eliminar a todos los usuarios excepto administradores y propietarios. Esto eliminará {count} usuarios, sus saldos de permisos y cualquier solicitud de permiso pendiente.",
        "warning": "Advertencia: Esta acción no se puede deshacer. Asegúrese de descargar una copia de seguridad primero.",
        "confirm_prompt": "Escriba DELETE para confirmar",
        "confirm_description": "Esto eliminará permanentemente {count} usuarios y todos sus datos.",
        "button": "Borrar usuarios no administradores",
        "confirm_button": "Confirmar eliminación de usuarios"
      },
      "clear_history": {
        "title": "Borrar historial de salidas",
        "description": "Eliminar todas las solicitudes de permiso y restablecer todos los saldos de permisos a cero. Esto eliminará {count} solicitudes de permiso.",
        "warning": "Advertencia: Esta acción no se puede deshacer. Se eliminará permanentemente todo el historial de bajas y se restablecerán los saldos.",
        "confirm_description": "Esto eliminará permanentemente {count} solicitudes de licencia y restablecerá todos los saldos.",
        "button": "Borrar historial de salidas",
        "confirm_button": "Confirmar Borrar Historial"
      },
      "restore": {
        "title": "Restaurar desde una copia de seguridad",
        "description": "Sube un archivo JSON de respaldo para restaurar los datos de tu espacio de trabajo. Esto reemplazará todos los datos existentes.",
        "warning": "Advertencia: La restauración reemplazará todos los usuarios, tipos de permisos, solicitudes de permisos, departamentos y saldos actuales. Solo el propietario del espacio de trabajo puede realizar esta acción.",
        "select_file": "Seleccionar archivo de respaldo",
        "backup_details": "Detalles de la copia de seguridad",
        "file": "Archivo",
        "version": "Versión",
        "created": "Creado",
        "confirm_prompt": "Escriba RESTORE para confirmar",
        "confirm_description": "Esto reemplazará permanentemente todos los datos existentes con la copia de seguridad.",
        "button": "Confirmar restauración",
        "restoring": "Restaurando...",
        "success": "¡Restauración completada exitosamente!"
      }
    }
  },
  "audit": {
    "page_title": "Pista de auditoría",
    "page_subtitle": "Ver todos los cambios realizados en su espacio de trabajo",
    "super_admin_label": "(Superadministrador)",
    "entries_count": "total de entradas",
    "filter": {
      "action_label": "Tipo de acción",
      "all_actions": "Todas las acciones",
      "entity_label": "Tipo de entidad",
      "all_entities": "Todas las entidades",
      "user_label": "Cambiado por",
      "all_users": "Todos los usuarios"
    },
    "action": {
      "user_updated": "Usuario actualizado",
      "user_deleted": "Usuario eliminado",
      "user_imported": "Importado por el usuario",
      "leave_requested": "Solicitud de licencia",
      "leave_approved": "Licencia aprobada",
      "leave_rejected": "Licencia rechazada",
      "leave_cancelled": "Licencia cancelada",
      "leave_type_created": "Tipo de licencia creado",
      "leave_type_updated": "Tipo de licencia actualizado",
      "leave_type_deleted": "Tipo de licencia eliminado",
      "balance_adjusted": "Saldo ajustado",
      "department_created": "Departamento creado",
      "department_updated": "Departamento Actualizado",
      "department_deleted": "Departamento eliminado",
      "audit_log_deleted": "Registro de auditoría eliminado"
    },
    "table": {
      "date": "Fecha",
      "user": "Usuario",
      "action": "Acción",
      "entity": "Entidad",
      "details": "Detalles"
    },
    "no_entries": "No se encontraron entradas del registro de auditoría"
  },
  "billing": {
    "page_title": "Facturación y suscripción",
    "page_subtitle": "Administra tu suscripción y detalles de facturación",
    "access_denied": {
      "title": "Acceso denegado",
      "message": "Sólo el propietario del espacio de trabajo puede ver y administrar la facturación.",
      "button": "Regresar al panel de control"
    },
    "current_plan": {
      "title": "Plan actual"
    },
    "status": {
      "none": "Sin suscripción"
    },
    "discount_badge": "{percent}% de descuento aplicado",
    "trial_info": {
      "title": "El juicio finaliza el {fecha}",
      "days_remaining": "{days} días restantes"
    },
    "renewal_info": {
      "title": "Próxima fecha de facturación"
    },
    "action": {
      "upgrade": "Actualizar a Pro",
      "view_plans": "Ver todos los planes",
      "manage": "Administrar suscripción"
    },
    "plan": {
      "trial": "Prueba gratuita",
      "free": "Gratis",
      "pro": "Pro",
      "business": "Negocio"
    },
    "feature": {
      "up_to_5_users": "Hasta 5 usuarios",
      "up_to_50_users": "Hasta 50 usuarios",
      "unlimited_users": "Usuarios ilimitados",
      "basic": "Características básicas",
      "trial_14days": "prueba de 14 días",
      "unlimited_requests": "Solicitudes de permiso ilimitadas",
      "slack_integration": "Integración de Slack",
      "planner": "Vista del planificador",
      "custom_leave_types": "Tipos de permisos personalizados",
      "approval_workflows": "Flujos de trabajo de aprobación",
      "priority_support": "Soporte prioritario",
      "multi_team": "Soporte multi-equipo",
      "analytics": "Análisis avanzado",
      "api_access": "Acceso a la API",
      "dedicated_support": "Soporte dedicado"
    }
  },
  "upgrade": {
    "page_title": "Elige tu plan",
    "page_subtitle": "Precios sencillos y transparentes. Sin comisiones por usuario.",
    "plan_badge": "Más populares",
    "period": {
      "month": "/mes",
      "year": "/año"
    },
    "yearly_savings": "o EUR {anual}/año (ahorre {porcentaje}%)",
    "loading": "Cargando planes...",
    "guarantee": {
      "title": "Garantía de devolución de dinero de 30 días",
      "description": "¿No estás satisfecho? Recibe un reembolso completo, sin preguntas."
    },
    "faq": {
      "title": "Preguntas frecuentes",
      "q1": "¿Puedo cambiar de planes más adelante?",
      "a1": "Sí, puedes actualizar o reducir tu plan en cualquier momento. Los cambios surten efecto de inmediato y se prorratean.",
      "q2": "¿Qué métodos de pago aceptan?",
      "a2": "Aceptamos todas las principales tarjetas de crédito (Visa, Mastercard, American Express) a través de nuestro proveedor de pagos seguros Stripe.",
      "q3": "¿Existe algún contrato o compromiso?",
      "a3": "No, todos los planes son mensuales. Puedes cancelar en cualquier momento sin penalizaciones.",
      "q4": "¿Qué pasa cuando llego a mi límite de usuarios?",
      "a4": "Se te solicitará que actualices a un plan superior. Los usuarios actuales seguirán teniendo acceso."
    },
    "contact_note": "¿Tienes preguntas? Contáctanos en",
    "current_plan_badge": "Plan actual",
    "button": {
      "upgrade": "Actualizar a {plan}",
      "start_trial": "Comience una prueba gratuita"
    }
  },
  "login": {
    "processing_title": "Registrandote...",
    "processing_message": "Espere mientras verificamos sus credenciales de Slack.",
    "subtitle": "Gestione las solicitudes de tiempo libre de su equipo con facilidad",
    "slack_button": "Agregar a Slack",
    "existing_user_text": "¿Ya estás usando Unplug?",
    "existing_user_info": "Abra la aplicación en Slack y haga clic en Panel de administración para iniciar sesión.",
    "terms_text": "Al continuar",
    "error": {
      "workspace_not_found": "No se encontró el espacio de trabajo. Por favor, revise la URL.",
      "invalid_response": "Respuesta no válida del servidor",
      "generic": "error de inicio de sesion",
      "please_retry": "Error al iniciar sesión. Inténtalo de nuevo."
    }
  },
  "help": {
    "page_title": "Centro de ayuda",
    "page_subtitle": "Encuentra respuestas y aprende a utilizar Unplug",
    "action": {
      "restart_tour": "Reiniciar Tour"
    },
    "search": {
      "placeholder": "Buscar artículos de ayuda, preguntas frecuentes...",
      "results": "Se encontraron {articles} artículos y {faqs} preguntas frecuentes que coinciden con {query}."
    },
    "quick_link": {
      "getting_started": "Empezando",
      "faqs": "Preguntas frecuentes",
      "contact_support": "Contactar con soporte técnico",
      "tour": "Realice el recorrido"
    }
  },
  "profile": {
    "page_title": "Configuración del perfil",
    "personal_info": "Información personal",
    "name_label": "Nombre completo",
    "email_label": "Correo electrónico",
    "department_label": "Departamento",
    "location_label": "Ubicación",
    "manager_label": "Gerente",
    "start_date_label": "Fecha de inicio",
    "save_button": "Guardar cambios",
    "preferences": "Preferencias",
    "language_label": "Idioma",
    "timezone_label": "Zona horaria"
  },
  "planner": {
    "page_title": "Planificador",
    "page_subtitle": "Calendario visual del equipo mostrando todas las ausencias",
    "feature_name": "Planificador",
    "feature_description": "Calendario visual del equipo mostrando todas las ausencias de un vistazo",
    "empty_state": "No se encontraron miembros del equipo",
    "filter": {
      "pending_request": "Solicitud pendiente",
      "filter_by": "Filtrar por",
      "department": "Departamento",
      "all_departments": "Todos los departamentos",
      "location": "Ubicación",
      "all_locations": "Todas las ubicaciones"
    },
    "export": {
      "button": "Exportar",
      "title": "Exportar datos de ausencias",
      "format": "Formato de exportación",
      "buddy_payroll": "Buddy Payroll",
      "generic_csv": "CSV genérico",
      "date_range": "Rango de fechas",
      "departments": "Departamentos"
    },
    "legend": {
      "approved": "Aprobado",
      "pending": "Pendiente",
      "holiday": "Festivo",
      "holidays": "Festivos",
      "weekend": "Fin de semana",
      "non_working": "Día no laborable",
      "partial_day": "Ausencias menores a un día"
    },
    "no_data": "No hay ausencias que mostrar"
  },
  "error": {
    "network": "Error de red. Por favor, revise su conexión.",
    "unauthorized": "No estás autorizado para realizar esta acción.",
    "not_found": "No se encontró el recurso solicitado.",
    "server": "Error del servidor. Inténtalo de nuevo más tarde.",
    "validation": "Por favor revise el formulario para ver si hay errores.",
    "generic": "Algo salió mal. Inténtalo de nuevo.",
    "session_expired": "Tu sesión ha expirado. Por favor, vuelve a iniciar sesión."
  },
  "success": {
    "saved": "Los cambios se guardaron correctamente.",
    "deleted": "Eliminado exitosamente",
    "created": "Creado exitosamente.",
    "updated": "Actualizado exitosamente.",
    "submitted": "Enviado exitosamente.",
    "sent": "Enviado exitosamente."
  },
  "weekday": {
    "monday": "Lunes",
    "tuesday": "Martes",
    "wednesday": "Miércoles",
    "thursday": "Jueves",
    "friday": "Viernes",
    "saturday": "Sábado",
    "sunday": "Domingo",
    "mon": "Lun",
    "tue": "Mar",
    "wed": "Casarse",
    "thu": "Jue",
    "fri": "Vie",
    "sat": "Se sentó",
    "sun": "Sol"
  },
  "month": {
    "january": "Enero",
    "february": "Febrero",
    "march": "Marzo",
    "april": "Abril",
    "may": "Puede",
    "june": "Junio",
    "july": "Julio",
    "august": "Agosto",
    "september": "Septiembre",
    "october": "Octubre",
    "november": "Noviembre",
    "december": "Diciembre",
    "jan": "Ene",
    "feb": "Feb",
    "mar": "Mar",
    "apr": "Abr",
    "may_short": "Puede",
    "jun": "Jun",
    "jul": "Jul",
    "aug": "Ago",
    "sep": "Sep",
    "oct": "Oct",
    "nov": "Nov",
    "dec": "Dic"
  },
  "language": {
    "en": "Inglés",
    "es": "Español",
    "fr": "Francés",
    "de": "Alemán",
    "it": "italiano",
    "pt": "portugués",
    "pl": "Polaco",
    "nl": "Holandés",
    "sv": "sueco",
    "no": "noruego"
  },
  "leave_type_name": {
    "Vacation": "Vacaciones",
    "Vacation Leave": "Vacaciones",
    "Annual Leave": "Vacaciones anuales",
    "Unpaid Vacation": "Vacaciones no remuneradas",
    "Unpaid Leave": "Permiso no remunerado",
    "Sick Leave": "Baja por enfermedad",
    "Sick Leave (Full Pay)": "Baja por enfermedad (sueldo completo)",
    "Maternity Leave": "Baja por maternidad",
    "Paternity Leave": "Baja por paternidad",
    "Parental Leave": "Permiso parental",
    "Bereavement Leave": "Permiso por duelo",
    "Marriage Leave": "Permiso por matrimonio",
    "Jury Leave": "Permiso por jurado",
    "Jury Duty": "Servicio de jurado",
    "Work Travel": "Viaje de trabajo",
    "Working Remotely": "Teletrabajo",
    "Remote Work": "Teletrabajo",
    "Work From Home": "Trabajo desde casa",
    "Personal Day": "Día personal",
    "TOIL": "Descanso compensatorio",
    "Time Off In Lieu": "Descanso compensatorio",
    "Compassionate Leave": "Permiso por motivos personales",
    "Study Leave": "Permiso de estudios",
    "Training": "Formación",
    "Public Holiday": "Festivo"
  }
}